import { forwardRef, type LabelHTMLAttributes } from 'react';
import { cn } from '../tokens/cn';
import type { VariantProps } from '../tokens/variants';
import { labelVariants } from './label.variants';

export interface LabelProps
  extends LabelHTMLAttributes<HTMLLabelElement>,
    VariantProps<typeof labelVariants> {
  required?: boolean;
  optionalText?: string;
}

export const Label = forwardRef<HTMLLabelElement, LabelProps>(
  ({ className, size, disabled, required, optionalText, children, ...props }, ref) => (
    <label ref={ref} className={cn(labelVariants({ size, disabled }), className)} {...props}>
      {children}
      {required && (
        <span aria-hidden="true" className="text-[var(--tk-danger-bg)]">
          *
        </span>
      )}
      {!required && optionalText && (
        <span className="text-[var(--tk-surface-fg-subtle)] font-normal">{optionalText}</span>
      )}
    </label>
  ),
);

Label.displayName = 'Label';
